'use client';

import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import { CalculatorProps } from '@/types';
import { Button } from '../Button/Button';

import { CalculatorMessages } from './components';
import { RangeCalculator } from './components/RangeCalculator/RangeCalculator';

import styles from './calculator.module.scss';
import { useVisible } from '@/hooks';

interface Props {
  data: CalculatorProps;
}

const components = (className?: string): JSXMapSerializer => ({
  heading2: ({ children }) => (
    <h2 className={`${styles.title} ${className ?? ''}`}>{children}</h2>
  ),
  heading4: ({ children }) => (
    <h4 className={`${styles.title} ${className ?? ''}`}>{children}</h4>
  ),
});

export const Calculator = ({ data }: Props) => {
  const isLarge =
    data.plateText &&
    (data.variation === 'large' || data.variation === 'medium');

  const [isVisible, id] = useVisible();

  return (
    <article
      className={`${styles.calculator} ${styles[data.variation]} ${isVisible ? styles.isVisible : ''}`}
      id={id}
    >
      <div className={`${styles.wrapper} ${styles[data.variation]}`}>
        <div className={`${styles.background} ${styles[data.variation]}`}>
          <div className={`${styles.title_wrapper} ${styles[data.variation]}`}>
            <PrismicRichText
              field={data.title}
              components={components(styles[data.variation])}
            />
          </div>
          {isLarge && (
            <div
              className={`${styles.text_wrapper} ${styles[data.variation]} ${isVisible ? styles.isVisible : ''}`}
            >
              <CalculatorMessages
                plate={data.plateText!}
                security={data.securityNotice!}
                variation={data.variation}
              />
            </div>
          )}
          <RangeCalculator data={data} isVisible={isVisible} />
        </div>
      </div>
      {data.illustrativeText && (
        <p className={`${styles.illustrativeText} ${styles[data.variation]}`}>
          {data.illustrativeText}
        </p>
      )}
      <Button
        link={data.buttonLink}
        text={data.buttonText}
        variation={data.buttonVariation || 'blue'}
        styles={`${styles.button} ${styles[data.variation]}`}
      />
    </article>
  );
};
